import React from "react";
import { PatientBillInfoDto } from "../../../../api-client";
import { Button as ShadButton } from "@/components/ui/button";

interface StandardPaymentButtonsProps {
  bill: PatientBillInfoDto;
  isRowBusy: (rxId?: string) => boolean;
  onClickPay: (bill: PatientBillInfoDto) => void;
  onClickBill: (bill: PatientBillInfoDto) => void;
  handleExternalBill: (bill: PatientBillInfoDto) => void;
}

const StandardPaymentButtons: React.FC<StandardPaymentButtonsProps> = ({
  bill,
  isRowBusy,
  onClickPay,
  onClickBill,
  handleExternalBill,
}) => {
  return (
    <>
      <ShadButton
        size="sm"
        className="h-7 rounded-lg border border-slate-200 bg-gradient-to-b from-white to-slate-50 px-2.5 text-sm font-medium text-slate-700 shadow-[0_1px_2px_rgba(0,0,0,0.08),inset_0_1px_0_rgba(255,255,255,0.6)] transition-all duration-200 hover:from-slate-50 hover:to-slate-100 hover:text-slate-900 hover:shadow-[0_2px_8px_rgba(0,0,0,0.12)] focus-visible:ring-2 focus-visible:ring-slate-300 focus-visible:ring-offset-1 active:scale-[0.97]"
        onClick={() => onClickPay(bill)}
      >
        Zahlen
      </ShadButton>

      <ShadButton
        size="sm"
        disabled={isRowBusy(bill.rxId)}
        className="h-7 rounded-lg border-0 bg-gradient-to-b from-[#a5515f] to-[#8a4150] px-2.5 text-sm font-medium text-white shadow-[0_1px_2px_rgba(138,65,80,0.35),inset_0_1px_0_rgba(255,255,255,0.2)] transition-all duration-200 hover:from-[#994a57] hover:to-[#73353f] hover:shadow-[0_2px_8px_rgba(138,65,80,0.45),inset_0_1px_0_rgba(255,255,255,0.25)] focus-visible:ring-2 focus-visible:ring-[#a5515f]/40 focus-visible:ring-offset-1 active:scale-[0.97] disabled:pointer-events-none disabled:opacity-50"
        onClick={() => onClickBill(bill)}
      >
        Rechnung erstellen
      </ShadButton>
    </>
  );
};

export default StandardPaymentButtons;
